<template>
    <b-row class="mt-3 pt-3">
        <b-col cols="3" class="list-col-vineta"  lg="4">
            <img class="list-vineta" src="@/assets/images/user_internal/vineta.png" alt="Double right arrow">
        </b-col>
        <b-col cols="6" class="pb-2"  lg="6">
            <b-row class="list-col-title">
                <span class="list-title-list" v-html="content.title"></span>
            </b-row>
            <b-row>
                <span class="list-content-list" v-html="content.content"></span>
            </b-row>
        </b-col>
        <b-col cols="3" class="pb-2"  lg="2">
        </b-col>
    </b-row>
</template>
<script>

    export default {
        name: 'section-list',
        components: {
        },
        props: {
            content: Object
        }
    }
</script>
<style scoped>
</style>